import { gql } from '@apollo/client'

export const All_ROLE_PERMISSIONS = gql`
  mutation GetAllRolePermissions($id_role: Int!) {
    getAllRolePermissions(id_role: $id_role) {
      role_name
      description
      rolePermissionsModule {
        id
        id_module
        id_submodule
        access_delete
        access_retrieve
        access_read
        access_edit
        access_export
        order
        module_info {
          name
          front_label
        }
        submodule_info {
          name
          front_label
        }
      }
    }
  }
`

export const UPDATE_ROLE_PERMISSIONS = gql`
  mutation UpdateRolePermission($id_role: Int!, $modules: [roleModuleInput!]!) {
    updateRolePermission(id_role: $id_role, modules: $modules)
  }
`
